





import { Component, Vue } from 'vue-property-decorator';

@Component({
  props: {
    inner: Boolean,
    main: Boolean,
    content: Boolean,
  },
})
export default class MainComponent extends Vue {
}
